import { SPINNER_SET, SPINNER_UNSET } from './actionTypes';

interface ActionType {
  type: 'SPINNER_SET' | 'SPINNER_UNSET';
}

export const showSpinner = (): ActionType => {
  return { type: SPINNER_SET };
};

export const hideSpinner = (): ActionType => {
  return { type: SPINNER_UNSET };
};
